module.exports = __webpack_public_path__ + "ad80880d2775599a240511b9c5816360.pdf";